export enum ActivityType {
  SarClosed = 5000,
  SarReOpened = 5001,
  SarsEmail = 5002,
  SarsAssigned = 5003,
  SarUnassigned = 5004,
  SarRejected = 5005,
  SarCreatedFromFoi = 5006,
  SarPaused = 5007,
  SarUnPaused = 5008
}
